var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t.shopping.quantity))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"right"},[_c('div',{staticClass:"num"},[_vm._v("1")])])
}]

export { render, staticRenderFns }